export var BackupAction;
(function (BackupAction) {
    BackupAction["create"] = "C";
    BackupAction["delete"] = "D";
    BackupAction["update"] = "U";
})(BackupAction || (BackupAction = {}));
//# sourceMappingURL=BackupAction.js.map